export const SettigsItem = {
	name: 'SettigsItem',
	position: {
		x: 200,
		y: 200
	},
	components: [
		{
			name: 'bgblue',
			type: 'Sprite',
			img: 'settings_page_item_bg_on',
			position: { x: 0, y: 0 }
		},
		{
			name: 'bgred',
			type: 'Sprite',
			img: 'settings_page_item_bg_off',
			position: { x: 0, y: 0 }
		},
		{
			name: 'itemheader',
			type: 'Text',
			position: { x: 43, y: 32 },
			text: 'SETTINGS_ITEM_INFO'
		},
		{
			name: 'itemsett',
			type: 'Text',
			position: { x: 43, y: 65 },
			text: 'SETTINGS_ITEM_TITLE'
		},
		{
			name: 'itemdesc',
			type: 'Text',
			position: { x: 43, y: 110 },
			text: 'SETTINGS_ITEM_DESC'
		},
		{
			name: 'switchbtn',
			type: 'SwitchButton',
			position: { x: 366, y: 52 },
			bgimg: 'switcher_btn_on',
			bg: 'switcher_back_on',
			fgimg: 'switcher_btn_off',
			fg: 'switcher_back_on',
			bgText: 'DOUBLE_CHANCE_SWITCHER_ON',
			fgText: 'DOUBLE_CHANCE_SWITCHER_OFF'
		}
	]
};
